import React from 'react';
import { ReactComponent as NftIcon } from '@app/assets/icons/nft-icon.svg';
import { ReactComponent as AcademicIcon } from '@app/assets/icons/academic-icon.svg';
import { ReactComponent as MockTestsIcon } from '@app/assets/icons/mock-tests-icon.svg';
import { ReactComponent as ResultIcon } from '@app/assets/icons/result-icon.svg';

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: 'common.nft-dashboard',
    key: 'nft-dashboard',
    // TODO use path variable
    url: '',
    icon: <NftIcon />,
  },
  {
    title: 'common.pte-academic',
    key: 'pte-academic',
    icon: <AcademicIcon />,
    children: [
      {
        title: 'common.speaking',
        key: 'academic-speaking',
        url: 'pte-academic/speaking',
      },
      {
        title: 'common.writing',
        key: 'academic-writing',
        url: 'pte-academic/writing',
      },
      {
        title: 'common.reading',
        key: 'academic-reading',
        url: 'pte-academic/reading',
      },
      {
        title: 'common.listening',
        key: 'academic-listening',
        url: 'pte-academic/listening',
      },
    ],
  },
  {
    title: 'common.mock-tests',
    key: 'mock-tests',
    // TODO use path variable
    url: '/mock-test',
    icon: <MockTestsIcon />,
  },
  {
    title: 'common.results',
    key: 'results',
    // TODO use path variable
    url: '/result',
    icon: <ResultIcon />,
  },
  {
    title: 'Manager image',
    key: 'manager-image',
    // TODO use path variable
    url: '/manager-image',
    icon: <ResultIcon />,
  },
];
